import styled from "@emotion/styled";
import { MDSPopover } from "../popover/popover";

export const StyledMDSPopover = styled(MDSPopover)`
  background: ${({ theme }) => theme.colors.white};
  padding: 0;
`;

export const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.white};
  padding: 0;
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.mediumLarge}px;
`;

export const StyledHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.smd};
  background: ${({ theme }) => theme.colors.grey.x25};
  border-top-left-radius: ${({ theme }) => theme.borderRadius.mediumLarge}px;
  border-top-right-radius: ${({ theme }) => theme.borderRadius.mediumLarge}px;
`;

export const StyledContent = styled.div``;
